module.exports = __webpack_public_path__ + "media/categories/3003-5fee524c.svg";